import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Impact from "./components/Impact";
import Donate from "./components/Donate";
import About from "./components/About";
import ThankYou from "./components/ThankYou"; // new page

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <Home />
            <Impact />
            <Donate />
            <About />
          </>
        } />
        <Route path="/thankyou" element={<ThankYou />} />
      </Routes>
    </Router>
  );
}

export default App;
